import {
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  VIEW_PROFILE,
  VIEW_PROFILE_SUCCESS,
  VIEW_PROFILE_ERROR,
} from "./actionTypes";

export const updateProfile = (data, callback) => {
  return {
    type: UPDATE_PROFILE,
    payload: data,
    callback
  };
};

export const updateProfileSuccess = (message) => {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    payload: message,
  };
};

export const updateProfileError = (message) => {
  return {
    type: UPDATE_PROFILE_ERROR,
    payload: message,
  };
};
// get individual user data
export const viewProfile = (userId, callback) => {
  return {
    type: VIEW_PROFILE,
    payload: userId,
    callback,
  };
};

export const viewProfileSuccess = (data) => {
  return {
    type: VIEW_PROFILE_SUCCESS,
    payload: data,
  };
};

export const viewProfileError = (data) => {
  return {
    type: VIEW_PROFILE_ERROR,
    payload: data,
  };
};

